import { Injectable } from '@angular/core';

declare global {
  interface Window {
    FrontChat?: any;
  }
}

@Injectable({
  providedIn: 'root'
})
export class FrontChatService {

  private readonly chatId = '95e0a511e9a28d7e45fa00c4a4e9b16a';
  private initialized = false;

  init(): void {

    if (!window.FrontChat || this.initialized) {
      return;
    }

    window.FrontChat('init', {
      chatId: this.chatId,
      useDefaultLauncher: true
    });

    this.initialized = true;

    this.waitForLauncher(() => {
      this.adjustLauncherPosition();
      this.observeLauncher();
      this.applyIdentity();
    });

  }

  private waitForLauncher(callback: () => void): void {

  const interval = setInterval(() => {

    const launcher = document.querySelector('[id*="front-chat"]') as HTMLElement;

    if (launcher) {

      clearInterval(interval);

      setTimeout(() => {
        callback();
      }, 1500);

    }

  }, 500);

}

  private adjustLauncherPosition(): void {

  const chat = document.querySelector('[id*="front-chat"]') as HTMLElement;

  if (!chat) return;

  const isExpanded = chat.offsetHeight > 200;

  if (isExpanded) {
    chat.style.setProperty('bottom', '0px', 'important');
    return;
  }

  if (window.innerWidth <= 768) {
    chat.style.setProperty('bottom', '50px', 'important');
  } else {
    chat.style.setProperty('bottom', '20px', 'important');
  }

}

  private observeLauncher(): void {

    const chat = document.querySelector('[id*="front-chat"]') as HTMLElement;

    if (!chat) return;

    const observer = new MutationObserver(() => {
      this.adjustLauncherPosition();
    });

    observer.observe(chat, {
      attributes: true,
      attributeFilter: ['style']
    });

  }

  applyIdentity(): void {

    if (!window.FrontChat) {
      return;
    }

    const rawUser = localStorage.getItem('user');

    if (rawUser) {

      const user = JSON.parse(rawUser);

      window.FrontChat('identity', {
        name: user?.userLoginInfo?.name || 'Usuário Vinhobid',
        email: user?.userLoginInfo?.email || undefined
      });

    } else {

      window.FrontChat('identity', {
        name: 'Visitante Vinhobid'
      });

    }

  }

  shutdown(): void {

    if (!window.FrontChat || !this.initialized) {
      return;
    }

    try {
      window.FrontChat('shutdown', { clearSession: true });
    } catch (_) { }

    this.initialized = false;

  }

  restartAsVisitor(): void {

    this.shutdown();

    setTimeout(() => {
      this.init();
    }, 300);

  }

}
